import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
	// we init with resources
	resources: {
		es: {
			translations: {
				'common.telus': 'Telus International',
				'layout.menu.about': 'About us',
				'layout.menu.join': 'Join our caring culture',
				'layout.menu.how-to-apply': 'How to apply',
				'layout.menu.benefits': 'Benefits',
				'layout.menu.facilities': 'Our Facilities',
				'layout.menu.values': 'Our Values ',
				'layout.menu.opportunities': 'Job opportunities',
				'home.herosection.title': 'Haz parte de nuestra cultura única',
			},
		},
	},
	fallbackLng: 'es',
	debug: true,

	// have a common namespace used around the full app
	ns: ['translations'],
	defaultNS: 'translations',

	keySeparator: false, // we use content as keys

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ',',
	},

	react: {
		wait: true,
	},
});

export default i18n;
